import gql from 'graphql-tag';

export const SEND_VERIFY_EMAIL = gql`
  mutation sendVerifyEmail {
    sendVerifyEmail {
      errors {
        field
        message
      }
    }
  }
`;
